<template>
  <FormContainer :title="$t('title.department')" :onSubmit="onSubmit">
    <div class="columns">
      <div class="column">
        <div v-if="parentDepartment" style="margin-bottom:15px">
          <b>{{ $t('title.parentDepartment') }}:</b> {{ parentDepartment.name }}
        </div>
        <FormItem>
          <b-input v-model="data.name" v-validate="'required'" name="name" expanded />
        </FormItem>
      </div>
    </div>
  </FormContainer>
</template>

<script>
import ApiService from '../../../_api/api.service'

export default {
  props: ['id', 'parentDepartment', 'companyId'],
  data () {
    return {
      data: {}
    }
  },
  mounted () {
    if (this.id) {
      this.getData()
    } else {
      this.data.companyId = this.companyId
    }
    if (this.parentDepartment) {
      this.data.parentProcessGroupId = this.parentDepartment.id
    }
  },
  methods: {
    getData () {
      ApiService.get(`/company/${this.companyId}/processgroup/${this.id}`).then(data => {
        this.data = data
      })
    },
    onSubmit () {
      ApiService.post('/company/processgroup', { processGroup: this.data }).then(data => {
        this.data = data
        this.$emit('saved')
        this.$parent.close()
      })
    }
  }
}
</script>
